import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Typography, useTheme } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { AnnouncementPanel, AnnouncementPanelHeader } from 'components/@common/AnnouncementPanel';

const ROSTER_SUPPORT_TOPIC_URL = '/support/8'; //TODO - Hardcoded and should go to the help topic for roster information.

const RosteringInformationAnnouncement = () => {
  const history = useHistory();
  const theme = useTheme();
  const { t } = useTranslation('RosteringInformationPanel');

  const handleClick = (path: string) => (): void => history.push(path);

  return (
    <AnnouncementPanel
      show
      borderColor={theme.palette.secondary.main}
      Header={<AnnouncementPanelHeader title={t('Rostering & Setup')} />}
      Actions={
        <Button
          variant="outlined"
          disableElevation
          aria-label={t('View More Information')}
          startIcon={<ArrowForwardIcon />}
          onClick={handleClick(ROSTER_SUPPORT_TOPIC_URL)}
        >
          {t('View More Information')}
        </Button>
      }
    >
      <Typography variant="body1" color="textSecondary">
        {t('Get everything you need for data integration options and instructions!')}
      </Typography>
    </AnnouncementPanel>
  );
};

export default RosteringInformationAnnouncement;
